import React from "react";
import { STATUS_STYLE } from "@/lib/apiClient";

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId || `status-badge-${status?.toLowerCase().replace(/\s/g, "-")}`}
    className={`inline-flex items-center rounded-full border px-3 py-1 text-[11px] font-semibold uppercase tracking-wider ${
      STATUS_STYLE[status] || "text-slate-300 bg-slate-800 border-slate-700"
    }`}
  >
    {status}
  </span>
);
